import React from 'react'
import ReactMarkdown from 'react-markdown'
import EditQuestionForm from '../containers/EditQuestionForm'

const Question = ({ question, categories, userCanEditFAQ }) =>
  <div className='lgy-question'>
    <div>
      <button className='usa-accordion-button' label='press enter to expand' aria-expanded='false' aria-controls={'faq' + question.id}>
        {question.question}
      </button>
      <div id={'faq' + question.id} className='usa-accordion-content'>
        <ReactMarkdown source={question.answer} />
        {userCanEditFAQ && <EditQuestionForm
          form={'faqForm' + question.id}
          question={question}
          categories={categories}
          initialValues={{ delete: false, ...question }} />}
      </div>
    </div>
  </div>

export default Question